import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=60754a7f&scoped=true"
import script from "./search-box.vue?vue&type=script&lang=js"
export * from "./search-box.vue?vue&type=script&lang=js"
import style0 from "./search-box.vue?vue&type=style&index=0&id=60754a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60754a7f",
  null
  
)

export default component.exports